import React from 'react';
import { Section } from './ui/Section';
import { Map, Clock, MessageCircle, Gift } from 'lucide-react';
export function Solution() {
  const features = [{
    icon: <Map className="w-8 h-8 text-white" data-id="element-169" />,
    title: 'Rutina Visual por Edad',
    desc: 'Versiones para 2-4, 5-8 y 9-13 años. Un mapa claro de qué sigue.',
    color: 'bg-[#4AAAA5]'
  }, {
    icon: <Clock className="w-8 h-8 text-white" data-id="element-170" />,
    title: 'Transiciones Visuales',
    desc: "Tarjetas de 'Primero-Después' para cortar el gatillo real del berrinche.",
    color: 'bg-[#E8845F]'
  }, {
    icon: <MessageCircle className="w-8 h-8 text-white" data-id="element-171" />,
    title: 'Guiones de 10 Segundos',
    desc: 'Frases exactas para poner límites sin entrar en negociación.',
    color: 'bg-[#F5C842]'
  }, {
    icon: <Gift className="w-8 h-8 text-white" data-id="element-172" />,
    title: 'Recompensas sin Sobornos',
    desc: 'Un sistema para mantener la constancia sin caer en el chantaje.',
    color: 'bg-indigo-500'
  }];
  return <Section background="teal" className="relative" data-id="element-173">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-174">
        <span className="text-[#4AAAA5] font-bold tracking-wider uppercase text-sm" data-id="element-175">
          La Solución
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-6" data-id="element-176">
          Presentando: Kit de Rutinas Visuales <br data-id="element-177" />{' '}
          <span className="text-[#4AAAA5]" data-id="element-178">Anti-Berrinches</span>
        </h2>
        <p className="text-xl text-gray-600" data-id="element-179">
          Un sistema imprimible para pegar en casa y convertir la mañana en una
          secuencia clara, visible y sostenida.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-180">
        {features.map((feature, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300" data-id="element-181">
            <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-6 ${feature.color} shadow-lg transform -rotate-3`} data-id="element-182">
              {feature.icon}
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-183">
              {feature.title}
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-184">
              {feature.desc}
            </p>
          </div>)}
      </div>

      <div className="mt-16 text-center" data-id="element-185">
        <p className="text-2xl font-handwriting text-[#E8845F] font-bold transform -rotate-1" data-id="element-186">
          "Menos palabras. Más estructura. Menos pelea."
        </p>
      </div>
    </Section>;
}